import styled from '@emotion/styled'
import { Check } from '@emotion-icons/fa-solid/Check'
import { Exclamation } from '@emotion-icons/fa-solid/Exclamation'
import { Colors, Shapes } from 'src/components/theme'
import { Snackbar, SnackbarProps } from '@mui/material'

const StyledSnackbar = styled(Snackbar)<{ type: 'success' | 'error' }>`
  padding: 0px;
  .MuiPaper-root {
    background-color: transparent;
    width: fit-content;
    box-shadow: none;
    padding: 0px;
  }
  .MuiSnackbarContent-message {
    display: flex;
    align-items: center;
    padding: ${Shapes.spacing[2]}px ${Shapes.spacing[4]}px;
    color: ${Colors.bgWhite};
    background: ${(props) => (props.type === 'success' ? Colors.primaryGreen400 : Colors.primaryRed400)};
    border-radius: ${Shapes.borderRadius}px;
  }
`

const SnackbarLabel = styled.span`
  font-size: 14px;
  margin-left: 10px;
`

type SnackbarMessageProps = {
  type?: 'success' | 'error'
  label: string
  open: boolean
  anchorOrigin?: SnackbarProps['anchorOrigin']
  onClose: () => void
}
export const SnackbarMessage = (props: SnackbarMessageProps) => {
  const { open, anchorOrigin, onClose, type = 'success', label } = props
  return (
    <StyledSnackbar
      style={{
        top: anchorOrigin?.vertical === 'top' ? '16px' : '16px',
        left: anchorOrigin?.horizontal === 'left' ? 'calc(350px + 80px + 16px)' : '16px',
      }}
      anchorOrigin={anchorOrigin}
      open={open}
      onClose={onClose}
      autoHideDuration={3000}
      type={type}
      message={
        <>
          {type === 'success' ? (
            <Check size={16} color={Colors.bgWhite} />
          ) : (
            <Exclamation size={16} color={Colors.bgWhite} />
          )}
          <SnackbarLabel>{label}</SnackbarLabel>
        </>
      }></StyledSnackbar>
  )
}
